import SVG from "../SVG";

export const TwitterRed = () => {
  return (
    <SVG
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2223 5.52055C16.6907 5.75666 16.1196 5.91555 15.5201 5.98721C16.1323 5.62055 16.6018 5.03999 16.8229 4.34777C16.2507 4.68721 15.6162 4.93388 14.9407 5.06721C14.4001 4.4911 13.6301 4.1311 12.7779 4.1311C11.1412 4.1311 9.81457 5.45833 9.81457 7.09444C9.81457 7.32666 9.84123 7.55333 9.89123 7.76944C7.42846 7.6461 5.24512 6.4661 3.7829 4.67277C3.52845 5.11055 3.38234 5.61944 3.38234 6.16333C3.38234 7.1911 3.90512 8.09833 4.70012 8.62944C4.21457 8.61388 3.75734 8.48055 3.3579 8.25888C3.3579 8.27166 3.3579 8.28333 3.3579 8.2961C3.3579 9.73221 4.37901 10.93 5.73512 11.2017C5.48679 11.2694 5.22457 11.3055 4.95401 11.3055C4.76345 11.3055 4.57734 11.2867 4.39679 11.2528C4.77401 12.43 5.86846 13.2872 7.16512 13.3111C6.15123 14.1061 4.87346 14.58 3.48457 14.58C3.24568 14.58 3.00957 14.5661 2.77734 14.5383C4.08901 15.3789 5.64623 15.8694 7.32012 15.8694C12.7712 15.8694 15.7512 11.3539 15.7512 7.43777C15.7512 7.30944 15.7485 7.18166 15.7429 7.05444C16.3223 6.6361 16.8251 6.11444 17.2223 5.52055Z"
        fill="#FE1F1F"
      />
    </SVG>
  );
};
